<template>
  <div class="admin">
    <AdminPage></AdminPage>
  </div>
</template>

<script>
import AdminPage from '@/components/AdminPage.vue';

export default {
  name: 'adminView',
  components: {
    AdminPage
  }
}
</script>
